export const SLIDE_UP_INITIAL = { y: 100, opacity: 0 };
export const SLIDE_UP_ANIMATE = {
  y: 0,
  opacity: 1,
  transition: {
    type: 'easeInOut',
    duration: 0.1,
  },
};
